import { GeometryType } from "@evergis/api";
import { useCallback } from "react";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { Point } from "@evergis/sgis/es/Point";
import { useMapContext } from "@evergis/react";
import { GEOCODE_PROVIDER } from "../../../resources/geocode";
import { useGeocode } from "./useGeocode";
import { getCoordinates, isCoordinates } from "../components/AddressSearch/getCoordinates";

type AddressCoordinates = {
  isCoordinates: (value: string) => boolean;
  getCoordinates: (value: string) => Coordinates | [];
  geolocateToCoordinates: (coordinates: Coordinates) => void;
};

export const createCoordinatesLabel = ([x, y]: Coordinates): string => `${x}° N, ${y}° E`;

export const useAddressCoordinates = (providerName: string = GEOCODE_PROVIDER): AddressCoordinates => {
  const [, { updateGeocodeItems }] = useGeocode(providerName);
  const { map } = useMapContext();

  const geolocateToCoordinates = useCallback(
    (coordinates: Coordinates) => {
      const { x, y } = new Point(coordinates).projectTo(map.crs);

      updateGeocodeItems([
        {
          address: createCoordinatesLabel(coordinates),
          center: [x, y],
          geometry: {
            type: GeometryType.Point,
            sr: map.crs.wkid,
            coordinates: [x, y],
          },
        },
      ]);
    },
    [map.crs, updateGeocodeItems],
  );

  return { isCoordinates, getCoordinates, geolocateToCoordinates };
};
